module.exports = __webpack_public_path__ + "img/logo-propel-dark.4eb72e7.svg";